import { STATUS_FIELD } from "modules/swiftboard/components/advance-filter";
import { RECIPIENT_TYPE_LABEL } from "./recipient-type.constants";

// Advanced filter of the Recipient Type list. Every key must also be in FILTER_FIELDS of the backend's
// reminder_setup/recipient_type/controller.js, the whitelist get-all filters on.
export const recipientTypeFilterFields = [
  {
    key: "type_key",
    label: "Recipient type",
    type: "enum",
    group: "Details",
    options: Object.entries(RECIPIENT_TYPE_LABEL).map(([value, label]) => ({ value, label })),
  },
  { key: "needs_subject", label: "Needs the subject", type: "boolean", group: "Details" },
  { ...STATUS_FIELD, group: "Details" },
  { key: "created_date", label: "Created", type: "datetime", group: "Dates" },
];
